import React from 'react';
import CardData from './CardData';

class Box extends React.Component {
    boxData = (params) => {
        this.setState({
            check:params
        })
    }
    render() {
        return (
            <>
                {/* <p>Im from Box</p> */}
                {/* <button className="btn btn-sm btn-primary" onClick={()=>this.props.boxCall(this.state.check)}>Box Submit</button> */}
                <CardData onCardData={this.boxData}/>

                
            </>
        )
    }
}

export default Box;
